export default __webpack_public_path__ + "static/media/book.0714fa72.png";